import React, { useCallback, useContext, useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { DEFAULT_PATHS, PATH } from "../routes/routes";
import * as StorageService from "../services/StorageServices";
import { APP_DOMAINS, LOCALSTORAGE_ITEMS, STATUSES, TYPES } from "../util/Constants";
import Alert from "./Alert";
import { clearStorageItemsAndLogout } from "../util/common";
import { PendingLeavesContext } from "../util/PendingLeavesContext";
import { useNavigate } from "react-router";
import * as ClientConfig from "../config/ClientConfig";
import sositoLogo from "../assets/img/logo.svg";
import innenuLogo from "../assets/img/logo_innenu.svg";


function Aside() {
    let location = useLocation();


    const companyInfo = StorageService.getItem(LOCALSTORAGE_ITEMS.COMPANY_INFO) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.COMPANY_INFO)) : null;
    const firstName = StorageService.getItem(LOCALSTORAGE_ITEMS.FIRST_NAME) || "Unknown";
    const lastName = StorageService.getItem(LOCALSTORAGE_ITEMS.LAST_NAME) || "Unknown";
    const type = StorageService.getItem(LOCALSTORAGE_ITEMS.TYPE) || "Unknown";
    const navigateTo = useNavigate();
    const pendingLeaveContext = useContext(PendingLeavesContext);
    const [state, setState] = useState({
        isLogoutAlertOpen: false,
    });





    const employeesIcon = <svg className="nav-link-icon" width="28" height="28" viewBox="0 0 32 20" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16 0.333313C17.2377 0.333313 18.4247 0.824978 19.2998 1.70015C20.175 2.57532 20.6667 3.7623 20.6667 4.99998C20.6667 6.23766 20.175 7.42464 19.2998 8.29981C18.4247 9.17498 17.2377 9.66665 16 9.66665C14.7623 9.66665 13.5753 9.17498 12.7002 8.29981C11.825 7.42464 11.3333 6.23766 11.3333 4.99998C11.3333 3.7623 11.825 2.57532 12.7002 1.70015C13.5753 0.824978 14.7623 0.333313 16 0.333313ZM6.66667 3.66665C7.41333 3.66665 8.10667 3.86665 8.70667 4.22665C8.50667 6.13331 9.06667 8.02665 10.2133 9.50665C9.54667 10.7866 8.21333 11.6666 6.66667 11.6666C5.6058 11.6666 4.58839 11.2452 3.83824 10.4951C3.08809 9.74493 2.66667 8.72751 2.66667 7.66665C2.66667 6.60578 3.08809 5.58836 3.83824 4.83822C4.58839 4.08807 5.6058 3.66665 6.66667 3.66665ZM25.3333 3.66665C26.3942 3.66665 27.4116 4.08807 28.1618 4.83822C28.9119 5.58836 29.3333 6.60578 29.3333 7.66665C29.3333 8.72751 28.9119 9.74493 28.1618 10.4951C27.4116 11.2452 26.3942 11.6666 25.3333 11.6666C23.7867 11.6666 22.4533 10.7866 21.7867 9.50665C22.9333 8.02665 23.4933 6.13331 23.2933 4.22665C23.8933 3.86665 24.5867 3.66665 25.3333 3.66665ZM7.33333 17.3333C7.33333 14.5733 11.2133 12.3333 16 12.3333C20.7867 12.3333 24.6667 14.5733 24.6667 17.3333V19.6666H7.33333V17.3333ZM0 19.6666V17.6666C0 15.8133 2.52 14.2533 5.93333 13.8C5.14667 14.7066 4.66667 15.96 4.66667 17.3333V19.6666H0ZM32 19.6666H27.3333V17.3333C27.3333 15.96 26.8533 14.7066 26.0667 13.8C29.48 14.2533 32 15.8133 32 17.6666V19.6666Z"
            fill="#5f6368" />
    </svg>

    const companiesIcon = <svg className="nav-link-icon" xmlns="http://www.w3.org/2000/svg" width="28" height="23"
        viewBox="0 0 28 23" fill="none">
        <path
            d="M10.0003 2.66667V4H18.0003V2.66667H10.0003ZM27.3337 20C27.3337 20.7067 27.0537 21.3333 26.5337 21.88C26.0003 22.4133 25.4003 22.6667 24.667 22.6667H3.33366C2.60033 22.6667 2.00033 22.4133 1.46699 21.88C0.946992 21.3333 0.666992 20.7067 0.666992 20V14.6667H7.33366V16H10.0003V14.6667H18.0003V16H20.667V14.6667H27.3337V20ZM4.00033 5.62667C4.45366 4.54667 5.26699 4 6.44033 4H7.33366V2.66667C7.33366 1.93333 7.57366 1.33333 8.09366 0.786667C8.61366 0.266667 9.25366 0 10.0003 0H18.0003C18.747 0 19.387 0.266667 19.907 0.786667C20.427 1.33333 20.667 1.93333 20.667 2.66667V4H21.5603C22.7337 4 23.547 4.54667 24.0003 5.62667L26.7737 12H20.667V10.6667H18.0003V12H10.0003V10.6667H7.33366V12H1.22699L4.00033 5.62667Z"
            fill="#5f6368" />
    </svg>

    const staffLogIcon = <svg className="nav-link-icon" width="28" height="28" viewBox="0 0 28 28" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M15.3344 0.706787V0.733454V3.40012C21.1877 4.12012 25.3344 9.44012 24.6144 15.2935C24.001 20.1468 20.1877 24.0001 15.3344 24.5735V27.2401C22.6677 26.5068 28.001 20.0001 27.2677 12.6668C26.6677 6.33345 21.641 1.33345 15.3344 0.706787ZM12.6677 0.746787C10.0677 1.00012 7.58771 2.00012 5.56104 3.68012L7.46771 5.65345C8.96104 4.45345 10.761 3.68012 12.6677 3.41345V0.746787ZM3.68104 5.56012C2.00104 7.58679 1.00104 10.0535 0.734375 12.6668H3.40104C3.65438 10.7735 4.40104 8.97345 5.58771 7.46679L3.68104 5.56012ZM0.747708 15.3335C1.01437 17.9468 2.04104 20.4135 3.69437 22.4401L5.58771 20.5335C4.41437 19.0268 3.65437 17.2268 3.41437 15.3335H0.747708ZM7.46771 22.4935L5.56104 24.3201C7.57437 26.0001 10.0544 27.0535 12.6677 27.3335V24.6668C10.7744 24.4268 8.97437 23.6668 7.46771 22.4935ZM14.6677 7.33345V14.3335L20.6677 17.8935L19.6677 19.5335L12.6677 15.3335V7.33345H14.6677Z" fill="#4D5062" />
    </svg>

    const adminIcon = <svg className="nav-link-icon" width="24" height="30" viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 0.333313L0 5.66665V13.6666C0 21.0666 5.12 27.9866 12 29.6666C18.88 27.9866 24 21.0666 24 13.6666V5.66665L12 0.333313ZM12 5.66665C13.0609 5.66665 14.0783 6.08807 14.8284 6.83822C15.5786 7.58836 16 8.60578 16 9.66665C16 10.7275 15.5786 11.7449 14.8284 12.4951C14.0783 13.2452 13.0609 13.6666 12 13.6666C10.9391 13.6666 9.92172 13.2452 9.17157 12.4951C8.42143 11.7449 8 10.7275 8 9.66665C8 8.60578 8.42143 7.58836 9.17157 6.83822C9.92172 6.08807 10.9391 5.66665 12 5.66665ZM18.84 21.6666C17.2267 24.1333 14.8133 25.9866 12 26.8933C9.18667 25.9866 6.77333 24.1333 5.16 21.6666C4.70667 21 4.32 20.3333 4 19.6266C4 17.4266 7.61333 15.6266 12 15.6266C16.3867 15.6266 20 17.3866 20 19.6266C19.68 20.3333 19.2933 21 18.84 21.6666Z"
            fill="#20A1BE" />
    </svg>

    const nfcTagsIcon = <svg className="nav-link-icon" width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.3333 11.7067L24.9867 1.93333L27.2933 3.26667L20.32 15.3333L11.64 10.3333L5.27999 21.3333H27.3333V24H0.666656V0H3.33332V19.3867L10.6667 6.66667L19.3333 11.7067Z" fill="#4D5062" />
    </svg>


    const reportsIcon = <svg className="nav-link-icon" width="28" height="24" viewBox="0 0 28 24" fill="#5f6368" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.3334 11.7067L24.9867 1.93333L27.2934 3.26667L20.3201 15.3333L11.6401 10.3333L5.28008 21.3333H27.3334V24H0.666748V0H3.33341V19.3867L10.6667 6.66667L19.3334 11.7067Z" fill="#4D5062" />
    </svg>

    const schedulerIcon = <svg className="nav-link-icon" width="27" height="30" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 16.3333H18V20.0933L21.2533 21.9733L20.2533 23.7067L16 21.2533V16.3333ZM21.3333 9.66668H2.66667V24.3333H8.89333C8.32 23.12 8 21.76 8 20.3333C8 17.858 8.98333 15.484 10.7337 13.7337C12.484 11.9833 14.858 11 17.3333 11C18.76 11 20.12 11.32 21.3333 11.8933V9.66668ZM2.66667 27C1.18667 27 0 25.8 0 24.3333V5.66668C0 4.18668 1.18667 3.00001 2.66667 3.00001H4V0.333344H6.66667V3.00001H17.3333V0.333344H20V3.00001H21.3333C22.0406 3.00001 22.7189 3.28096 23.219 3.78106C23.719 4.28116 24 4.95943 24 5.66668V13.8C25.6533 15.48 26.6667 17.7867 26.6667 20.3333C26.6667 22.8087 25.6833 25.1827 23.933 26.933C22.1827 28.6833 19.8087 29.6667 17.3333 29.6667C14.7867 29.6667 12.48 28.6533 10.8 27H2.66667ZM17.3333 13.8667C15.6183 13.8667 13.9734 14.548 12.7607 15.7607C11.548 16.9735 10.8667 18.6183 10.8667 20.3333C10.8667 23.9067 13.76 26.8 17.3333 26.8C18.1825 26.8 19.0234 26.6327 19.808 26.3078C20.5926 25.9828 21.3055 25.5065 21.906 24.906C22.5064 24.3055 22.9828 23.5926 23.3078 22.808C23.6327 22.0235 23.8 21.1826 23.8 20.3333C23.8 16.76 20.9067 13.8667 17.3333 13.8667Z" fill="#4D5062" />
    </svg>

    const holidayIcon = <svg className="nav-link-icon" width="30" height="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#5f6368"><path d="m792-125.33-260-260 49.33-49.34 260 260L792-125.33Zm-562-40q-92-97.34-107.17-225.34-15.16-128 43.84-239.66Q169-597 182-555.83q13 41.16 36.5 86.16t56.17 92.84q32.66 47.83 73 93.83L230-165.33Zm163.33-163.34Q344.67-378 308.67-434.5T253.5-543.67q-19.17-52.66-20-96.5-.83-43.83 20.83-66.83 23-24.67 67.84-24.67 44.83 0 99.33 18.84 54.5 18.83 112 54.66 57.5 35.84 104.83 84.5l-245 245ZM684-619.33q-45-40.34-92.5-72.67t-93.33-55.67q-45.84-23.33-88-36.16Q368-796.67 334-798.33q112.33-60 241.5-44.5 129.17 15.5 225.83 106.16L684-619.33Z" /></svg>

    const locationIcon = <svg className="nav-link-icon" width="28" height="28" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.4279 8.0299C16.4251 7.9411 16.4203 7.85229 16.4147 7.76349C16.3273 6.21004 15.7875 4.71657 14.8624 3.46847C13.9372 2.22037 12.6673 1.27263 11.2105 0.742888C11.1731 0.729164 11.1365 0.715037 11.0991 0.702524C10.9383 0.647224 10.7775 0.597981 10.6168 0.552773C10.5319 0.529361 10.4475 0.507559 10.3623 0.486973C10.2281 0.455489 10.0938 0.424411 9.95714 0.399385C9.82771 0.374763 9.69786 0.357003 9.56763 0.339647C9.46352 0.325923 9.36062 0.309373 9.2553 0.299282C9.01091 0.275871 8.76611 0.26416 8.52091 0.26416C8.48072 0.26416 8.43691 0.269413 8.3951 0.270221C8.3533 0.271028 8.31149 0.26416 8.26969 0.26416C8.02449 0.26416 7.77957 0.275871 7.53491 0.299282C7.43 0.30897 7.32669 0.325519 7.22298 0.339647C7.09275 0.357003 6.9625 0.374763 6.83307 0.399385C6.6964 0.424411 6.56216 0.455489 6.4283 0.486973C6.34309 0.507425 6.25827 0.529361 6.17386 0.552773C6.01026 0.597981 5.84907 0.647224 5.6915 0.702524C5.65412 0.71544 5.61714 0.729568 5.57975 0.742888C4.12293 1.27265 2.85314 2.22041 1.92802 3.46851C1.00291 4.71661 0.46321 6.21008 0.375942 7.76349C0.370047 7.85229 0.365487 7.9411 0.362272 8.0299C0.362272 8.09126 0.353027 8.151 0.353027 8.21275C0.353027 8.27451 0.360261 8.32537 0.361467 8.38228C0.363879 8.58411 0.374732 8.78593 0.392017 8.98775C0.394026 9.00874 0.39564 9.02812 0.398052 9.05032C0.626769 11.4472 1.93435 13.6252 3.96507 14.9936C4.11621 15.0949 5.31486 15.8299 6.12039 16.4003C7.1655 17.1402 7.59399 17.8425 7.76241 18.1061C7.91158 18.339 8.03862 18.5855 8.14187 18.8424C8.1622 18.8936 8.19737 18.9375 8.24284 18.9685C8.28831 18.9995 8.34198 19.016 8.39691 19.016C8.45184 19.016 8.50552 18.9995 8.55098 18.9685C8.59645 18.9375 8.63162 18.8936 8.65195 18.8424C8.75416 18.5864 8.87999 18.3406 9.02779 18.1081C9.19581 17.8445 9.62552 17.1422 10.6698 16.4023C11.4737 15.832 12.674 15.0969 12.8247 14.9956C14.8559 13.6272 16.1634 11.4492 16.3922 9.05233C16.3946 9.03174 16.3958 9.01197 16.3978 8.98977C16.4155 8.78822 16.4257 8.5864 16.4283 8.3843C16.4283 8.32739 16.4368 8.27208 16.4368 8.21477C16.4368 8.15745 16.4295 8.09126 16.4279 8.0299ZM8.39349 12.5834C7.5708 12.5834 6.76659 12.3384 6.08255 11.8795C5.39851 11.4205 4.86538 10.7681 4.55057 10.0048C4.23576 9.24159 4.1534 8.40173 4.31393 7.59148C4.47446 6.78122 4.87066 6.03697 5.45242 5.45283C6.03418 4.86869 6.77536 4.47091 7.58226 4.30979C8.38915 4.14867 9.2255 4.23144 9.98555 4.54764C10.7456 4.86384 11.3952 5.39927 11.8522 6.08621C12.3092 6.77316 12.5531 7.58077 12.553 8.4069C12.5531 8.95542 12.4455 9.49857 12.2365 10.0053C12.0275 10.5121 11.7211 10.9726 11.3348 11.3604C10.9486 11.7483 10.49 12.0559 9.9853 12.2657C9.48063 12.4756 8.93973 12.5835 8.39349 12.5834Z" fill="#4D5062" />
    </svg>

    const serviceIcon = (

        <svg className="nav-link-icon" width="30" height="30" viewBox="0 -960 960 960" fill="#5f6368"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q13-36 43.5-58t68.5-22q38 0 68.5 22t43.5 58h168q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm80-80h280v-80H280v80Zm0-160h400v-80H280v80Zm0-160h400v-80H280v80Zm200-190q13 0 21.5-8.5T510-820q0-13-8.5-21.5T480-850q-13 0-21.5 8.5T450-820q0 13 8.5 21.5T480-790ZM200-200v-560 560Z" /></svg>
    );

    const inspectionIcon = (
        <svg className="nav-link-icon" width="30" height="30" viewBox="0 -960 960 960" fill="#5f6368"><path d="m438-338 226-226-57-57-169 169-84-84-57 57 141 141Zm-198 218q-33 0-56.5-23.5T160-200v-560q0-33 23.5-56.5T240-840h280l240 240v400q0 33-23.5 56.5T680-120H240Zm240-448v-192H240v560h440v-368H480ZM240-760v192-192 560-560Z" /></svg>
    );

    const insightsIcon = <svg className="nav-link-icon" width="28" height="28" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" ><path d="M120-120v-80h120v80H120Zm0-160v-80h320v80H120Zm0-160v-80h720v80H120Zm0-160v-80h320v80H120Zm0-160v-80h120v80H120Zm200 640v-80h120v80H320Zm0-640v-80h120v80H320Zm200 640v-80h120v80H520Zm0-160v-80h320v80H520Zm0-320v-80h320v80H520Zm0-160v-80h120v80H520Zm200 640v-80h120v80H720Zm0-640v-80h120v80H720Z" fill="#4D5062" /></svg>

    const analyticsIcon = <svg className="nav-link-icon" width="28" height="28" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M640-160v-280h160v280H640Zm-240 0v-640h160v640H400Zm-240 0v-440h160v440H160Z" fill="#4D5062" /></svg>

    const requestsIcon = <svg className="nav-link-icon" width="28" height="28" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M80-40v-80h800v80H80Zm80-120v-240q-33-54-51-114.5T91-638q0-61 15.5-120T143-874q8-21 26-33.5t40-12.5q31 0 53 21t18 50l-11 91q-6 48 8.5 91t43.5 75.5q29 32.5 70 52t89 19.5q60 0 120.5 12.5T706-472q45 23 69.5 58.5T800-326v166H160Zm80-80h480v-86q0-24-12-42.5T674-398q-41-20-95-31t-99-11q-66 0-122.5-27t-96-72.5Q222-585 202-644.5T190-768q-10 30-14.5 64t-4.5 66q0 58 20.5 111.5T240-422v182Zm240-320q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm0-80q33 0 56.5-23.5T560-720q0-33-23.5-56.5T480-800q-33 0-56.5 23.5T400-720q0 33 23.5 56.5T480-640ZM320-160v-37q0-67 46.5-115T480-360h160v80H480q-34 0-57 24.5T400-197v37h-80Zm160-80Zm0-480Z" fill="#4D5062" /></svg>


    const openLogoutAlert = (e) => {
        e.stopPropagation();
        setState({
            ...state,
            isLogoutAlertOpen: true,
        });
    }

    const hideAlert = () => {

        setState({
            ...state,
            isLogoutAlertOpen: false,
            selectedAccount: null
        })
    }

    const getLogoPath = useCallback(() => {
        const companyId = companyInfo?.id; // or props.companyId if you pass it in
        if (type === TYPES.WORKER && companyId) {
            return PATH.SERVICE_BONURI(companyId);
        }
        return PATH.ALL_COMPANIES;
    }, [type, companyInfo?.id]);


    const getActiveRoute = () => {
        if (location.pathname.indexOf(DEFAULT_PATHS.STATISTICS) >= 0) {
            return DEFAULT_PATHS.STATISTICS;
        } else if (location.pathname.indexOf(DEFAULT_PATHS.AI_INSIGHTS) >= 0) {
            return DEFAULT_PATHS.AI_INSIGHTS;
        } else if (location.pathname.indexOf(DEFAULT_PATHS.REQUESTS) >= 0) {
            return DEFAULT_PATHS.REQUESTS;
        } else if (location.pathname.indexOf(DEFAULT_PATHS.COMPANIES) >= 0) {
            return DEFAULT_PATHS.COMPANIES;
        } else if (location.pathname.indexOf(DEFAULT_PATHS.EMPLOYEES) >= 0) {
            return DEFAULT_PATHS.EMPLOYEES;
        } else if (location.pathname.indexOf(DEFAULT_PATHS.COMPANY) >= 0) {
            return DEFAULT_PATHS.COMPANY;
        } else if (location.pathname.indexOf(DEFAULT_PATHS.NFC_TAGS) >= 0) {
            return DEFAULT_PATHS.NFC_TAGS;
        } else if (location.pathname.indexOf(DEFAULT_PATHS.STAFF_LOG) >= 0 && type === TYPES.SUPER_ADMIN) {
            return DEFAULT_PATHS.COMPANIES;
        } else if (location.pathname.indexOf(DEFAULT_PATHS.STAFF_LOG) >= 0) {
            return DEFAULT_PATHS.STAFF_LOG;
        } else if (location.pathname.indexOf(DEFAULT_PATHS.SCHEDULER) >= 0) {
            return DEFAULT_PATHS.SCHEDULER;
        } else if (location.pathname.indexOf(DEFAULT_PATHS.VACATION_PLANNER) >= 0) {
            return DEFAULT_PATHS.VACATION_PLANNER;
        } else if (location.pathname.indexOf(DEFAULT_PATHS.INSPECTIONS) >= 0) {
            return DEFAULT_PATHS.INSPECTIONS;
        } else if (location.pathname.indexOf(DEFAULT_PATHS.SERVICE_DOCS) >= 0) {
            return DEFAULT_PATHS.SERVICE_DOCS;
        }
    }



    const toProfilePage = () => {
        navigateTo(PATH.PROFILE);
    }


    return (
        <>
            {state.isLogoutAlertOpen &&
                <Alert
                    title={<FormattedMessage id="Logout" defaultMessage="Logout" />}
                    contentRow1={<FormattedMessage id="LogoutConfirmation" defaultMessage="LogoutConfirmation" />}
                    deleteAction1={() => clearStorageItemsAndLogout()}
                    deleteText1={<FormattedMessage id="Logout" defaultMessage="Logout" />}
                    cancelAction={() => hideAlert()}
                    cancelText={<FormattedMessage id="Cancel" defaultMessage="Cancel" />}
                    hideAlert={() => hideAlert()}
                />
            }

            <aside className="aside">
                <section className="logo">
                    <Link tabIndex={-1} to={getLogoPath()}>

                        {ClientConfig.APP_DOMAIN === APP_DOMAINS.APP_SOSITO_RO ?
                            <img src={sositoLogo} alt="application logo" />
                            :
                            <img src={innenuLogo} alt="application logo" />
                        }


                    </Link>
                </section>
                <section className="row account-info">
                    <div className="col user-photo">
                        <div className="col">
                            <div className="colored-div">
                                <p>
                                    {
                                        (firstName[0] ? firstName[0] : "")
                                        + (firstName[1] ? firstName[1] : "")
                                        + (lastName[0] ? lastName[0] : "")
                                        + (lastName[1] ? lastName[1] : "")
                                    }
                                </p>
                                {type === TYPES.SUPER_ADMIN || type === TYPES.ADMIN || type === TYPES.MANAGER ?
                                    <p className="admin-icon">{adminIcon}</p>
                                    : null}
                            </div>

                        </div>
                    </div>
                    <div className="col user-info">
                        <div className="row">
                            <p>{firstName} &nbsp; {lastName}</p>
                        </div>
                        <div className="row">
                            <p className="faded-text">{type}</p>
                        </div>
                    </div>
                </section>
                {(type !== TYPES.SUPER_ADMIN && type !== TYPES.WORKER) && <section className="account-settings">
                    <a onClick={(e) => toProfilePage()} className="link warning account-settings-link"><FormattedMessage id="Settings" defaultMessage="Settings" /></a>

                </section>}

                <section className="nav">
                    <ul className="nav-links">
                        {/*{(type === TYPES.MANAGER || type === TYPES.ADMIN) && <NavLink tabIndex={-1}*/}
                        {/*                                                              className={getActiveRoute() === DEFAULT_PATHS.DEMO_STAFF_LOG ? "nav-link active" : "nav-link"}*/}
                        {/*                                                              to={PATH.DEMO_LIVE_TRACKER(companyInfo.id)}>*/}
                        {/*    {staffLogIcon}*/}
                        {/*    <FormattedMessage id="DEMO_StaffLog" defaultMessage="DEMO_StaffLog"/>*/}
                        {/*</NavLink>}*/}
                        {/*{(type === TYPES.MANAGER || type === TYPES.ADMIN) && <NavLink tabIndex={-1}*/}
                        {/*                                                              className={getActiveRoute() === DEFAULT_PATHS.DEMO_REPORTS ? "nav-link active" : "nav-link"}*/}
                        {/*                                                              to={PATH.DEMO_REPORTS(companyInfo.id)}>*/}
                        {/*    {reportsIcon}*/}
                        {/*    <FormattedMessage id="DEMO_Reports" defaultMessage="DEMO_Reports"/>*/}
                        {/*</NavLink>}*/}
                        {(type === TYPES.MANAGER || type === TYPES.ADMIN) && <NavLink tabIndex={-1}
                            className={getActiveRoute() === DEFAULT_PATHS.STAFF_LOG ? "nav-link active" : "nav-link"}
                            to={PATH.LIVE_TRACKER(companyInfo.id)}>
                            {staffLogIcon}
                            <FormattedMessage id="StaffLog" defaultMessage="StaffLog" />
                        </NavLink>}


                        {type === TYPES.MANAGER && <NavLink tabIndex={-1}
                            className={getActiveRoute() === DEFAULT_PATHS.EMPLOYEES ? "nav-link active" : "nav-link"}
                            to={PATH.COMPANIES_EMPLOYEES(companyInfo.id)}>
                            {employeesIcon}
                            <FormattedMessage id="Employees" defaultMessage="Employees" />
                        </NavLink>}

                        {type === TYPES.MANAGER && <NavLink tabIndex={-1}
                            className={getActiveRoute() === DEFAULT_PATHS.LOCATIONS ? "nav-link active" : "nav-link"}
                            to={PATH.COMPANIES_LOCATIONS(companyInfo.id)}>
                            {locationIcon}
                            <FormattedMessage id="Locations" defaultMessage="Locations" />
                        </NavLink>}

                        {type === TYPES.ADMIN && <NavLink tabIndex={-1}
                            className={getActiveRoute() === DEFAULT_PATHS.COMPANIES ? "nav-link active" : "nav-link"}
                            to={PATH.COMPANIES_EMPLOYEES(companyInfo.id)}>
                            {companiesIcon}
                            <FormattedMessage id="Company" defaultMessage="Company" />
                        </NavLink>}


                        {type === TYPES.SUPER_ADMIN && <NavLink tabIndex={-1} className={getActiveRoute() === DEFAULT_PATHS.COMPANIES ? "nav-link active" : "nav-link"} to={PATH.ALL_COMPANIES}>
                            {companiesIcon}
                            <FormattedMessage id="Companies" defaultMessage="Companies" />
                        </NavLink>}

                        {type === TYPES.SUPER_ADMIN && <NavLink tabIndex={-1} className={getActiveRoute() === DEFAULT_PATHS.NFC_TAGS ? "nav-link active" : "nav-link"} to={PATH.ALL_NFC_TAGS}>
                            {nfcTagsIcon}
                            <FormattedMessage id="NfcTags" defaultMessage="NfcTags" />
                        </NavLink>}



                        {(type === TYPES.MANAGER || type === TYPES.ADMIN) && <NavLink tabIndex={-1}
                            className={getActiveRoute() === DEFAULT_PATHS.REPORTS ? "nav-link active" : "nav-link"}
                            to={PATH.REPORTS(companyInfo.id)}>
                            {reportsIcon}
                            <FormattedMessage id="Reports" defaultMessage="Reports" />
                        </NavLink>}


                        {companyInfo?.availableClientForms && (
                            <NavLink
                                tabIndex={-1}
                                className={getActiveRoute() === DEFAULT_PATHS.SERVICE_DOCS ? "nav-link active" : "nav-link"}
                                to={PATH.SERVICE(companyInfo.id)}
                            >
                                {serviceIcon}
                                Documente
                            </NavLink>
                        )}

                        {(companyInfo?.locationInspectionEnabled && type !== TYPES.WORKER) && (
                            <NavLink
                                tabIndex={-1}
                                className={getActiveRoute() === DEFAULT_PATHS.INSPECTIONS ? "nav-link active" : "nav-link"}
                                to={PATH.INSPECTIONS(companyInfo.id)}
                            >
                                {inspectionIcon}
                                <FormattedMessage id="Inspections" defaultMessage="Inspections" />
                            </NavLink>
                        )}

                        {/* {(type === TYPES.MANAGER || type === TYPES.ADMIN) && <NavLink tabIndex={-1}
                                                                                      className={getActiveRoute() === DEFAULT_PATHS.STATISTICS ? "nav-link active" : "nav-link"}
                                                                                      to={PATH.COMPANIES_STATISTICS(companyInfo.id)}>
                            {analyticsIcon}
                            <FormattedMessage id="Statistics" defaultMessage="Statistics"/>
                        </NavLink>} */}






                        {(companyInfo?.schedulerEnabled && (type === TYPES.MANAGER || type === TYPES.ADMIN)) &&
                            <NavLink tabIndex={-1}
                                className={getActiveRoute() === DEFAULT_PATHS.SCHEDULER ? "nav-link active" : "nav-link"}
                                to={PATH.SCHEDULER_WORK_HOURS(companyInfo.id)}>
                                {schedulerIcon}
                                <FormattedMessage id="Scheduler" defaultMessage="Scheduler" />
                            </NavLink>}

                        {(companyInfo?.leaveEnabled && (type === TYPES.MANAGER || type === TYPES.ADMIN)) &&
                            <NavLink tabIndex={-1}
                                className={getActiveRoute() === DEFAULT_PATHS.VACATION_PLANNER ? "nav-link active" : "nav-link"}
                                to={PATH.VACATION_REQUESTS(companyInfo.id)}>
                                {holidayIcon}
                                <FormattedMessage id="VacationPlanner" defaultMessage="VacationPlannerAll" />
                                {pendingLeaveContext.pendingLeavesCount > 0 && <span className="notifications">{pendingLeaveContext.pendingLeavesCount}</span>}
                            </NavLink>}

                        {/*
                        {(type === TYPES.MANAGER || type === TYPES.ADMIN) && <NavLink tabIndex={-1}
                                                                                      className={getActiveRoute() === DEFAULT_PATHS.AI_INSIGHTS ? "nav-link active" : "nav-link"}
                                                                                      to={PATH.COMPANIES_AI_INSIGHTS(companyInfo.id)}>
                            {insightsIcon}
                            <FormattedMessage id="AiInsights" defaultMessage="AiInsights"/>
                        </NavLink>} */}

                        {/*{(type === TYPES.MANAGER || type === TYPES.ADMIN) && <NavLink tabIndex={-1}*/}
                        {/*                                                              className={getActiveRoute() === DEFAULT_PATHS.REQUESTS ? "nav-link active" : "nav-link"}*/}
                        {/*                                                              to={PATH.COMPANIES_REQUESTS(companyInfo.id)}>*/}
                        {/*    {requestsIcon}*/}
                        {/*    <FormattedMessage id="Requests" defaultMessage="Requests"/>*/}
                        {/*</NavLink>}*/}



                        <a onClick={(e) => openLogoutAlert(e)} className="only-for-desktop link neutral logout-link"><FormattedMessage id="Logout" defaultMessage="Logout" /></a>
                    </ul>
                </section>
            </aside>

        </>
    );
}

export default Aside;
